import { css } from "styled-components";
import { BladeHeaderTitle, BladeHeaderBody, BladeHeaderSupertitle, BladeHeaderSubtitle, } from "../../../../components/BladeHeader";
import { CTA } from "../../../../components/CTA";
export const riotProductSkin = (chroma) => css `
  display: flex;
  justify-content: space-between;
  gap: ${chroma.spacers.constant.xs};
  margin-bottom: ${chroma.spacers.variable.l};

  /* increase specificity with a double ampersand */
  &&:empty {
    margin-bottom: 0;
  }

  ${chroma.mediaQueries.mobileDown} {
    flex-direction: column;
  }

  .content {
    display: flex;
    flex-direction: column;
    max-width: 650px;
  }

  ${BladeHeaderSupertitle} {
    ${chroma.typography.body5};
    font-weight: 500;

    &:not(:last-child) {
      margin-bottom: ${chroma.spacers.variable.xxs};
    }
  }

  ${BladeHeaderTitle} {
    ${chroma.typography.display6};
    &:not(:last-child) {
      margin-bottom: ${chroma.spacers.variable.s};
    }
  }

  ${BladeHeaderSubtitle} {
    ${chroma.typography.body5};
    font-weight: 500;

    &:not(:last-child) {
      margin-bottom: ${chroma.spacers.variable.xxs};
    }
  }

  ${BladeHeaderBody} {
    ${chroma.typography.body5};
  }

  ${CTA} {
    align-self: flex-end;
    justify-self: flex-end;
    text-wrap: nowrap;

    ${chroma.mediaQueries.mobileDown} {
      align-self: flex-start;
      justify-self: flex-start;
    }
  }
`;
//# sourceMappingURL=index.js.map